/**
 * The message banner's standard look (prototype: .bnHost and .banner, the app's client banner):
 * strong glass, the tapered accent border, the studio's mark, its name in the serif, the start of
 * the message, now and a chevron. Under the site header in the stacking order, so it never covers
 * it. Draws the behavior half's state and calls its actions; holds no rule.
 */
import { partsOf, pieceRoot } from '../../contract/runtime';
import { Icon } from '../../ui/Icon';
import type { MessageBannerRuntime } from './useMessageBanner';
import css from './MessageBanner.module.css';
import { contract } from './contract';

const part = partsOf(contract);

export function MessageBannerView({ state, actions }: MessageBannerRuntime) {
  const { banner } = state;
  const className = [css.host, state.leaving && css.out, state.queued && css.queued].filter(Boolean).join(' ');
  return (
    <div className={className} aria-live="polite" hidden={!banner} {...pieceRoot(contract)} {...part('host')}>
      {banner && (
        <button
          key={banner.id}
          type="button"
          className={css.banner}
          aria-label={`${state.studioName}: ${banner.preview}. Open messages`}
          onClick={actions.open}
          {...part('banner')}
        >
          {state.logoUrl ? (
            <img className={css.logo} src={state.logoUrl} alt="" {...part('logo')} />
          ) : (
            <span className={css.noMark} aria-hidden="true">
              <Icon name="msg" />
            </span>
          )}
          <span className={css.info}>
            <span className={css.title} {...part('title')}>
              {state.studioName}
            </span>
            <span className={css.detail} {...part('preview')}>
              {banner.preview}
            </span>
          </span>
          <span className={css.aside}>
            <span className={css.time} {...part('time')}>
              now
            </span>
            <svg className={css.chev} viewBox="0 0 24 24" aria-hidden="true">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </span>
        </button>
      )}
    </div>
  );
}
